var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"top"},[_c('upload',{model:{value:(_vm.picture),callback:function ($$v) {_vm.picture=$$v},expression:"picture"}}),_c('img',{attrs:{"src":_vm.picture}})],1),_c('div',{staticClass:"createpost-container"})])}
var staticRenderFns = []

export { render, staticRenderFns }